var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83333 3.83333H7.16667V5.5H8.83333V3.83333ZM8.83333 7.16667H7.16667V8.83333H8.83333V7.16667ZM12.1667 7.16667H10.5V8.83333H12.1667V7.16667ZM0.5 0.5V15.5H15.5V0.5H0.5ZM13.8333 13.8333H2.16667V2.16667H13.8333V13.8333ZM8.83333 10.5H7.16667V12.1667H8.83333V10.5ZM5.5 7.16667H3.83333V8.83333H5.5V7.16667Z",
    fill: "var(--icon-color, #BEC5D1)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHall);
export default __webpack_public_path__ + "static/media/hall.0fc225e1d120facef45085dec1f11810.svg";
export { ForwardRef as ReactComponent };